const DeleteDialog = ({ location, onClose, onConfirm }) => {
  if (!location) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-sm shadow-lg relative">
        <h2 className="text-xl font-semibold mb-4">Delete Location</h2>
        <p className="mb-6">
          Are you sure you want to hide <strong>{location.name}</strong>?
          Related shifts will remain intact.
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            // onClick={() => onConfirm(location._id)}
            onClick={() => onConfirm()}
            className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteDialog;
